import React from 'react';

const Hero = () => {
  return (
    <section 
      className="min-h-screen bg-cover bg-center bg-no-repeat flex items-center justify-center"
      style={{
        backgroundImage: "url('https://i.postimg.cc/V6BR4gCP/Portada-RIO-playa.png')"
      }}
    >
      {/* Sección completamente vacía, solo fondo */}
    </section>
  );
};

export default Hero;